var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBilling(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Outline/file-text"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Mask",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 14H9.00001C8.44801 14 8.00001 13.552 8.00001 13C8.00001 12.448 8.44801 12 9.00001 12H12C12.552 12 13 12.448 13 13C13 13.552 12.552 14 12 14ZM8.00001 17C8.00001 16.448 8.44801 16 9.00001 16H15C15.553 16 16 16.448 16 17C16 17.552 15.553 18 15 18H9.00001C8.44801 18 8.00001 17.552 8.00001 17ZM17.4443 20H6.55531C6.24931 20 6.00031 19.776 6.00031 19.5V4.5C6.00031 4.224 6.24931 4 6.55531 4H12.0003V7.15C12.0003 8.722 13.2173 10 14.7143 10H18.0003V19.5C18.0003 19.776 17.7513 20 17.4443 20ZM14.0003 4.978L16.7423 8H14.7143C14.3203 8 14.0003 7.619 14.0003 7.15V4.978ZM19.7403 8.328L14.2963 2.328C14.1063 2.119 13.8383 2 13.5553 2H6.55531C5.14631 2 4.00031 3.122 4.00031 4.5V19.5C4.00031 20.878 5.14631 22 6.55531 22H17.4443C18.8533 22 20.0003 20.878 20.0003 19.5V9C20.0003 8.751 19.9073 8.512 19.7403 8.328Z",
    fill: "#0C2551"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_1957",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 2,
    width: 17,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Mask_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 14H9.00001C8.44801 14 8.00001 13.552 8.00001 13C8.00001 12.448 8.44801 12 9.00001 12H12C12.552 12 13 12.448 13 13C13 13.552 12.552 14 12 14ZM8.00001 17C8.00001 16.448 8.44801 16 9.00001 16H15C15.553 16 16 16.448 16 17C16 17.552 15.553 18 15 18H9.00001C8.44801 18 8.00001 17.552 8.00001 17ZM17.4443 20H6.55531C6.24931 20 6.00031 19.776 6.00031 19.5V4.5C6.00031 4.224 6.24931 4 6.55531 4H12.0003V7.15C12.0003 8.722 13.2173 10 14.7143 10H18.0003V19.5C18.0003 19.776 17.7513 20 17.4443 20ZM14.0003 4.978L16.7423 8H14.7143C14.3203 8 14.0003 7.619 14.0003 7.15V4.978ZM19.7403 8.328L14.2963 2.328C14.1063 2.119 13.8383 2 13.5553 2H6.55531C5.14631 2 4.00031 3.122 4.00031 4.5V19.5C4.00031 20.878 5.14631 22 6.55531 22H17.4443C18.8533 22 20.0003 20.878 20.0003 19.5V9C20.0003 8.751 19.9073 8.512 19.7403 8.328Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_1957)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\xF0\x9F\x8E\xA8 Color"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base",
    width: 24,
    height: 24,
    fill: "currentColor"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBilling);
export default __webpack_public_path__ + "static/media/billing.98d5678a5b0a0178811e09cf3ef1d713.svg";
export { ForwardRef as ReactComponent };